import { Modal } from 'antd';

const { confirm } = Modal;

export const showDeleteConfirm = (
  func,
  title,
  tr,
  url,
  data,
  activeTourTab
) => {
  confirm({
    title,
    okText: tr.Yes,
    okType: 'danger',
    cancelText: tr.No,
    onOk() {
      func(url, data, activeTourTab);
    },
    onCancel() {
      return null;
    },
  });
};
